const FLAVOR_VERSIONS = [
  'scarlet',
  'violet',
  'legends-arceus',
  'sword',
  'shield',
  'ultra-sun',
  'ultra-moon',
  'sun',
  'moon',
  'x',
  'y',
  'black-2',
  'white-2',
  'black',
  'white',
  'heartgold',
  'soulsilver',
  'platinum',
  'diamond',
  'pearl',
  'firered',
  'leafgreen',
  'emerald',
  'ruby',
  'sapphire',
  'crystal',
  'gold',
  'silver',
  'yellow',
  'red',
  'blue',
];

export function pickFlavor(entries) {
  const english = (entries || []).filter((entry) => entry.language?.name === 'en' && entry.flavor_text);
  if (!english.length) return null;
  const rank = new Map(FLAVOR_VERSIONS.map((name, index) => [name, index]));
  english.sort((a, b) => {
    const aRank = rank.has(a.version?.name) ? rank.get(a.version.name) : 999;
    const bRank = rank.has(b.version?.name) ? rank.get(b.version.name) : 999;
    return aRank - bRank;
  });
  const chosen = english[0];
  return {
    text: chosen.flavor_text.replace(/\f/g, ' ').replace(/\s+/g, ' ').trim(),
    version: chosen.version?.name || null,
  };
}

export async function flavorFor(id, signal) {
  try {
    const response = await fetch(`https://pokeapi.co/api/v2/pokemon-species/${id}`, {
      headers: { Accept: 'application/json' },
      signal,
    });
    if (!response.ok) return null;
    const payload = await response.json();
    return pickFlavor(payload.flavor_text_entries);
  } catch (error) {
    if (error?.name === 'AbortError') throw error;
    return null;
  }
}
